import { GET_STARTED_STEPS } from '@/config/static/workspace';

interface GetStartedBannerProps {
  completedCount: number;
  isStepComplete?: (stepId: string) => boolean;
  onDismiss: () => void;
  onTryStep: (stepId: string) => void;
}

export function GetStartedBanner({
  completedCount,
  isStepComplete,
  onDismiss,
  onTryStep,
}: GetStartedBannerProps) {
  const total = GET_STARTED_STEPS.length;
  const pct = (completedCount / total) * 100;

  return (
    <div className="get-started-banner">
      <div className="get-started-banner__header">
        <span className="get-started-banner__heading">Get started</span>
        <div className="get-started-banner__progress-wrap">
          <div className="get-started-banner__progress-bar">
            <div
              className="get-started-banner__progress-fill"
              style={{ width: `${pct}%` }}
            />
          </div>
          <span className="get-started-banner__progress-label">
            {completedCount} of {total} done
          </span>
        </div>
        <button className="get-started-banner__close" onClick={onDismiss} aria-label="Dismiss">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
      </div>

      <div className="get-started-banner__steps">
        {GET_STARTED_STEPS.map((step, index) => {
          const done = isStepComplete?.(step.id) ?? false;

          return (
            <div
              key={step.id}
              className={`get-started-step${done ? ' get-started-step--done' : ''}`}
            >
              <div className="get-started-step__num" aria-hidden>
                {done ? (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                      d="M2.5 7.25L5.75 10.5L11.5 3.5"
                      stroke="currentColor"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              <div className="get-started-step__body">
                <p className="get-started-step__title">{step.title}</p>
                <p className="get-started-step__desc">{step.desc}</p>
              </div>
              {done ? (
                <span className="get-started-step__done">Done</span>
              ) : (
                <button
                  className="get-started-step__try"
                  type="button"
                  onClick={() => onTryStep(step.id)}
                >
                  Try it
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
